import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { BannerService } from "../api";

export const actionGetBanner = createAsyncThunk(
  "banner/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await BannerService.doGetBanner();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

const bannerInSlice = createSlice({
  name: "banner",
  initialState: {
    getBanner: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get banner
      .addCase(actionGetBanner.pending, (state) => {
        state.getBanner.loading = true;
      })
      .addCase(actionGetBanner.fulfilled, (state, action) => {
        state.getBanner.loading = false;
        state.getBanner.data = action.payload;
      })
      .addCase(actionGetBanner.rejected, (state, action) => {
        state.getBanner.loading = false;
        state.getBanner.data = action.payload;
        state.getBanner.error = action.error.message || "Something went wrong";
      });
  },
});

export default bannerInSlice.reducer;
export const { actions, reducer } = bannerInSlice;
